import { useState, useEffect } from 'react';

const usePageVisibility = () => {
  const [visible, setVisible] = useState(true);

  const handleVisibilityChange = () => {
    setVisible(document.visibilityState === 'visible');
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return visible;
};

export default usePageVisibility;
